// extracted by mini-css-extract-plugin
var _1 = "thUo3nTHTsJDT4eYXcwk";
var _2 = "ZBMfK9PDUGRlLRWLk2CZ";
var _3 = "aNOQ6_tT6cwEVWOxgCXM";
var _4 = "clVI4n4q3bxQyClOjJzH";
var _5 = "LGF_axG1yFi62gS1MILQ";
var _6 = "kYm9RbvgEL_nYLuM0Ojw";
var _7 = "gjJwuOyG6Bw2IyvrkD5y";
var _8 = "PzFEKWEIu_qg0kNmNx3T";
export { _1 as "button", _2 as "icon", _3 as "move-stripes", _4 as "size-lg", _5 as "size-sm", _6 as "type-dark", _7 as "type-orange", _8 as "type-secondary" }
